var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "border" },
    [
      _c(
        "h2",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Create New Client")]),
              _vm.showAlert
                ? _c("Alert", {
                    staticClass: "mx-4 my-2",
                    attrs: { text: "Client created!", type: "success" },
                  })
                : _vm._e(),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        [
          _c(
            "v-container",
            { staticClass: "pt-4 px-8" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Name", required: "" },
                        model: {
                          value: _vm.newClient.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.newClient, "name", $$v)
                          },
                          expression: "newClient.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Email", required: "" },
                        model: {
                          value: _vm.newClient.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.newClient, "email", $$v)
                          },
                          expression: "newClient.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Phone", required: "" },
                        model: {
                          value: _vm.newClient.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.newClient, "phone", $$v)
                          },
                          expression: "newClient.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Address" },
                        model: {
                          value: _vm.newClient.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.newClient, "address", $$v)
                          },
                          expression: "newClient.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "6" } }),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _vm.creating
                        ? _c("v-progress-circular", {
                            staticClass: "px-8",
                            attrs: { indeterminate: "" },
                          })
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-sm-right mt-2 mx-2",
                          attrs: { small: "" },
                          on: { click: _vm.createClient },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-plus-box-outline"),
                          ]),
                          _vm._v(" Create "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-sm-right mt-2",
                          attrs: { small: "" },
                          on: { click: _vm.cancelCreate },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("mdi-cancel"),
                          ]),
                          _vm._v(" Cancel "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }